import React, { useCallback, useEffect, useState } from 'react';
import useTranslate from '../../../../../Hooks/useTranslate';
import { useAtomValue, useAtom } from 'jotai';
import useAPI from '../../../../../api';
import { Tabs, Tab } from '@mui/material';
import { userBranchesAtom } from '../../../../../Atoms';
import { genericFormAtom } from '../../../../../store/genericFormStore';
import Dialog from '../../../../../Components/Dialog';
import SchemaWrapper from '../../../../../Components/engine/SchemaWrapper';
import { ColumnFlexBox } from '../../../../../Components/FlexBox';
import formatSchemaPayload from '../../../Utils/formatSchemaPayload';
import formatSchemaWithDefaultValues from '../../../Utils/formatSchemaWithDefaultValues';
import groupBy from '../../../../../Helpers/Arrays/groupBy';

const ConfigurationDialog = function ConfigurationDialog({
  open,
  onClose,
  filters,
  onSubmit,
  branchId,
  tabs = [],
}) {
  const translate = useTranslate();
  const API = useAPI();
  const [payload, setPayload] = useAtom(genericFormAtom);
  const userBranches = useAtomValue(userBranchesAtom);
  const [tabValue, setTabValue] = useState(0);
  const [waveFilters, setWaveFilters] = useState([]);

  const handleSubmit = useCallback(() => {
    if (onSubmit) {
      onSubmit({ branchId, schema: formatSchemaPayload(payload, branchId) });
    }
  }, [payload, branchId, onSubmit]);

  useEffect(() => {
    if (!open) return;

    API.getWaveFilterBranches(
      branchId,
      (res) => {
        setWaveFilters(res);
      },
      () => {}
    );
  }, [open, branchId]);

  useEffect(() => {
    if (!tabs || tabs.length === 0) return;

    setTabValue(tabs[0]?.id || '');
  }, [tabs]);

  const handleChangeTab = (event, newTab) => {
    setTabValue(newTab);
  };

  return (
    <Dialog
      id="configuration-dialog"
      open={open}
      onClose={() => {
        onClose();
        setPayload({ formChanged: false }); // Reset form state on close
      }}
      width="lg"
      fullWidth
      disableEscapeKeyDown
      disableBackdropClick
      onSubmit={handleSubmit}
      styles={{
        content: { overflow: 'hidden' },
      }}
      dividers
      titleColor="primary"
      overTitle="WAVE_CONFIGURATION"
      title={`${translate('IMPORT_FILTERS')} - ${userBranches?.find(({ id }) => id === branchId)?.branchDescription || ''}`}
    >
      <ColumnFlexBox overflow="auto" width="100%">
        <Tabs
          variant="fullWidth"
          value={tabValue}
          onChange={handleChangeTab}
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'dark' ? '#3d3d3d' : 'background.paper',
            position: 'sticky',
            top: 0,
            zIndex: 10,
          }}
        >
          {tabs.map(({ id, name }) => (
            <Tab key={id} value={id} label={translate(name)} />
          ))}
        </Tabs>
        <SchemaWrapper
          dynamicFilters={groupBy(
            waveFilters?.filter(({ sectionId }) =>
              tabs.find(({ id }) => id === sectionId)
            ),
            'sectionId'
          )}
          formatSchemaCallback={formatSchemaWithDefaultValues}
          tabValue={tabValue}
        />
      </ColumnFlexBox>
    </Dialog>
  );
};

export default ConfigurationDialog;
